import { Flex, type FlexProps } from "@mantine/core";

import AppStatus from "@/components/AppStatus/AppStatus";
import ColorSchemeSwitch from "@/components/ColorSchemeSwitch";
import LocaleSelectorGlobal from "@/components/Locale/LocaleSelectorGlobal";
import TermsMenu from "@/components/TermsMenu";

interface NavbarUtilityBarProps extends FlexProps {
  withColorScheme?: boolean;
  withStatus?: boolean;
  withLocale?: boolean;
  withTerms?: boolean;
  statusCollapsed?: boolean;
}
export const NavbarUtilityBar = ({
  withColorScheme = true,
  withStatus = true,
  withLocale = true,
  withTerms = true,
  statusCollapsed,
  ...props
}: NavbarUtilityBarProps) => {
  return (
    <Flex gap="xs" align="center" justify="center" wrap="wrap" {...props}>
      {withColorScheme && <ColorSchemeSwitch />}
      {withStatus && <AppStatus collapsed={statusCollapsed} />}
      {withLocale && <LocaleSelectorGlobal />}
      {withTerms && <TermsMenu />}
    </Flex>
  );
};

export default NavbarUtilityBar;
